module.exports = __webpack_public_path__ + "img/icon-mail.6aaf8d44.svg";